var RedirectModule = (function () {
    function RedirectModule() {
    }
    return RedirectModule;
}());
export { RedirectModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/redirect/redirect.module.ts.pre-build-optimizer.js